module.exports = __webpack_public_path__ + "img/平顶山市-c.34beeb31.png";